module.exports = __webpack_public_path__ + "static/img/1.ed137a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/1.png
// module id = xdgE
// module chunks = 0